module.exports = __webpack_public_path__ + "static/media/rules.e18c0582.png";


//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/img/rules.png
// module id = 1121
// module chunks = 0